import type { Competitor } from './types'
import linktree from './competitors/linktree'
import gunslol from './competitors/gunslol'
import beacons from './competitors/beacons'
import carrd from './competitors/carrd'
import biolink from './competitors/biolink'
import later from './competitors/later'
import stan from './competitors/stan'
import ezbio from './competitors/ezbio'
import lnkbio from './competitors/lnkbio'
import milkshake from './competitors/milkshake'
import fedslol from './competitors/fedslol'

// Competitor comparison pages, in hub order. Adding one: create a file in
// competitors/, add it here, and reserve its slug (and aliases) as usernames
// (guides/29.comparison-pages.md). Routes, prerendering, redirects, the
// sitemap, llms.txt, and llms-full.txt all pick it up from this list.
export const COMPETITORS: Competitor[] = [
  linktree,
  gunslol,
  beacons,
  carrd,
  stan,
  later,
  biolink,
  lnkbio,
  milkshake,
  fedslol,
  ezbio
]

export function getCompetitor(slug: string): Competitor | undefined {
  return COMPETITORS.find(c => c.slug === slug)
}

/** /linktree-alternative */
export function alternativePath(slug: string): string {
  return `/${slug}-alternative`
}
